// src/client/game/scenes/MenuScene.ts

import Phaser from "phaser";
import { createLevelSelectOverlay, type LevelSelectOverlay } from "../ui/LevelSelectOverlay";
import {
  initSfxEnabled,
  getSfxEnabled,
} from "../audio/sfxSettings";
import { setGlobalSfxEnabled } from "../audio/Sfx"; // ✅ new import

const BUTTON_WIDTH = 260;
const BUTTON_HEIGHT = 54;
const BUTTON_COLOR = 0xffcc33;
const BUTTON_TEXT_COLOR = "#000000";

type MenuButtonSpec = {
  label: string;
  sceneKey: string | null;
};

export class MenuScene extends Phaser.Scene {
  private levelUI: LevelSelectOverlay | null = null;
  constructor() {
    super("MenuScene");
  }

  create(): void {
    // ✅ Initialize sound settings and apply globally
    initSfxEnabled(this);
    setGlobalSfxEnabled(getSfxEnabled(this));

    const { width, height } = this.scale;
    this.cameras.main.setBackgroundColor("#000000");

    const title = this.add
      .text(width / 2, height * 0.18, "Laser Snake", {
        fontFamily: "monospace",
        fontSize: "40px",
        color: "#ffffff",
      })
      .setOrigin(0.5);

    const subtitle = this.add
      .text(width / 2, title.y + 40, "Classic Snake, re-loaded.", {
        fontFamily: "monospace",
        fontSize: "18px",
        color: "#cccccc",
      })
      .setOrigin(0.5);

    // Level selector (persisted via localStorage).
    this.levelUI?.destroy();
    this.levelUI = createLevelSelectOverlay(this);
    this.levelUI.layout(width / 2, subtitle.y + 80, 0.9);


    const specs: MenuButtonSpec[] = [
      { label: "Play game", sceneKey: "SnakeGameScene" },
      { label: "Instructions", sceneKey: "InstructionsScene" },
      { label: "Leaderboard", sceneKey: "LeaderboardScene" },
      { label: "Config", sceneKey: "ConfigScene" },
    ];

    const levelBottom = (this.levelUI as any).getBottomY?.() ?? (subtitle.y + 160);
    const startY = levelBottom + 70;
    const gap = 72;

    specs.forEach((spec, index) => {
      const y = startY + index * gap;
      this.createButton(width / 2, y, spec);
    });
  }

  private createButton(x: number, y: number, spec: MenuButtonSpec): void {
    const bg = this.add
      .rectangle(x, y, BUTTON_WIDTH, BUTTON_HEIGHT, BUTTON_COLOR)
      .setOrigin(0.5);
    bg.setStrokeStyle(2, 0x000000);
    bg.setInteractive({ useHandCursor: true });

    const label = this.add.text(x, y, spec.label, {
      fontFamily: "monospace",
      fontSize: "24px",
      color: BUTTON_TEXT_COLOR,
    });
    label.setOrigin(0.5);

    bg
      .on("pointerdown", () => {
        bg.setScale(0.97);
        label.setScale(0.97);
      })
      .on("pointerup", () => {
        bg.setScale(1);
        label.setScale(1);
        if (spec.sceneKey) {
          this.scene.start(spec.sceneKey);
        }
      })
      .on("pointerout", () => {
        bg.setScale(1);
        label.setScale(1);
      });
  }
}
